import { useState, useEffect } from "react";

const usePagination = (data: any) => {
  const currentData: any = data || [];

  const [currentPage, setCurrentPage] = useState(1);

  const rowsPerPage = 15;

  const totalPages = Math.ceil(currentData.length / rowsPerPage);

  useEffect(() => {
    setCurrentPage(1);
  }, [currentData]);

  const handlePageChange = (page: number) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const startIndex = (currentPage - 1) * rowsPerPage;
  const currentItems = currentData.slice(startIndex, startIndex + rowsPerPage);

  return {
    currentData,
    currentItems,
    currentPage,
    totalPages,
    handlePageChange,
    setCurrentPage,
  };
};

export default usePagination;
